import { ReactElement } from 'react'
import { Tooltip } from 'app/components/Tooltip'
import { Badge } from 'app/components/ui/badge'

/** Where a section's numbers come from while the tab mixes simulated and real data (plan D23). */
export type DataSource = `live` | `preview`

const SOURCE = {
  live: { label: `Live`, color: `green`, message: `Real records from this workspace and date range.` },
  preview: {
    label: `Preview`,
    color: `amber`,
    message: `Simulated until the SMS ops API ships, so it won't match the Live lists.`,
  },
} as const

/**
 * Marks a section Live or Preview next to its title, so nobody has to remember the notice at
 * the top of the tab. Delete with `smsAgentOpsMock.ts`, when every section is live.
 */
export function DataSourceBadge({ source }: { source: DataSource }): ReactElement {
  const { label, color, message } = SOURCE[source]
  return (
    <Tooltip message={message} placement="bottom">
      <Badge label={label} color={color} />
    </Tooltip>
  )
}
